import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ShieldCheck, KeyRound } from 'lucide-react';
import { toast } from 'sonner';
import { api, errorMessage } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function ResetPassword() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const token = search.get('token') || '';
  const [pw, setPw] = useState({ next: '', confirm: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setError('');
    if (pw.next.length < 8) { setError('New password must be at least 8 characters.'); return; }
    if (pw.next !== pw.confirm) { setError('Passwords do not match.'); return; }
    setBusy(true);
    try { const { data } = await api.post('/auth/reset', { token, newPassword: pw.next }); toast.success(`Password updated for ${data.email}. Sign in with it now.`); navigate('/login'); }
    catch (err) { setError(errorMessage(err)); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-paper-100 flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="reset-form">
        <div className="flex items-center gap-2 mb-8"><span className="h-9 w-9 rounded-lg bg-ink-700 text-white flex items-center justify-center"><ShieldCheck className="h-5 w-5" /></span><span className="font-semibold text-ink-800">Evidencer</span></div>
        <h2 className="text-2xl font-semibold tracking-tight text-ink-800 flex items-center gap-2"><KeyRound className="h-5 w-5 text-ink-400" />Choose a new password</h2>
        <p className="text-sm text-ink-500 mt-1 mb-6">Links are valid for one hour and can be used once.</p>
        {!token && <div data-testid="reset-no-token" className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800 mb-4">This link is missing its token. Open the link from your email again, or <Link to="/login" className="underline">request a new one</Link>.</div>}
        <div className="space-y-4">
          <div className="space-y-1.5"><Label htmlFor="np">New password</Label><Input id="np" data-testid="reset-new" type="password" value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} className="h-10 bg-white" autoComplete="new-password" /></div>
          <div className="space-y-1.5"><Label htmlFor="cp">Confirm password</Label><Input id="cp" data-testid="reset-confirm" type="password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} className="h-10 bg-white" autoComplete="new-password" /></div>
          {error && <div data-testid="reset-error" className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
          <Button data-testid="reset-submit" type="submit" disabled={busy || !token} className="w-full h-10 bg-ink-700 hover:bg-ink-800 text-white">{busy ? 'Saving…' : 'Set new password'}</Button>
          <div className="text-center text-sm"><Link to="/login" className="text-ink-500 hover:text-ink-800 underline underline-offset-2">Back to sign in</Link></div>
        </div>
      </form>
    </div>
  );
}
